// v1.2.0 · Barra fija en móvil: «Cotizar proyecto» y WhatsApp siempre a mano.
//           Aparece después del hero y se oculta cuando el formulario de contacto está en pantalla.
import React, { useEffect, useState } from 'react';
import { MessageCircle } from 'lucide-react';
import { contactData } from '../../data/site';

export default function SiteStickyCta() {
  const [pastHero, setPastHero] = useState(false);
  const [atContact, setAtContact] = useState(false);

  useEffect(() => {
    const onScroll = () => setPastHero(window.scrollY > 640);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    let obs;
    const el = document.getElementById('contacto');
    if (el && 'IntersectionObserver' in window) {
      obs = new IntersectionObserver(([e]) => setAtContact(e.isIntersecting), { threshold: 0.15 });
      obs.observe(el);
    }
    return () => { window.removeEventListener('scroll', onScroll); if (obs) obs.disconnect(); };
  }, []);

  const show = pastHero && !atContact;
  return (
    <div className="sticky-cta fixed inset-x-0 bottom-0 z-40 border-t border-[var(--line)] bg-white/95 backdrop-blur lg:hidden"
         data-show={show} aria-hidden={!show}>
      <div className="flex gap-2">
        <a href="#contacto" tabIndex={show ? 0 : -1} className="btn-go flex-1 justify-center !py-3 text-[16px]"
           data-testid="sticky-cta-cotizar">
          Cotizar proyecto
        </a>
        <a href={contactData.whatsappLink} target="_blank" rel="noopener noreferrer" tabIndex={show ? 0 : -1}
           aria-label="Escribir por WhatsApp" className="btn-quiet !px-4 !py-3">
          <MessageCircle size={20} className="text-[#25A244]" aria-hidden />
        </a>
      </div>
    </div>
  );
}
